import { Injectable, EventEmitter } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class BlockService {
  is_display_block_register_component = false;
  BlockUpdate = new EventEmitter<ZONE>();

  downloadBlock = new EventEmitter<boolean>();

  private _block_data: Block = null;
  constructor() { }

  set set_block_data(block) {
    this._block_data = block;
  }

  get get_block_data() {
    return this._block_data;
  }
}


export interface Block {
  id: number;
  name: string;
}